module.exports = __webpack_public_path__ + "static/img/GretelBueta.107fcdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GretelBueta.jpg
// module id = KhAV
// module chunks = 0